import useSWR, { KeyedMutator } from 'swr';
import { Attachment } from '../types';
import { apiClient } from '../services/apiClient';

interface UseAttachmentsReturn {
  attachments: Attachment[];
  loading: boolean;
  error: Error | undefined;
  mutate: KeyedMutator<Attachment[]>;
}

// Fetcher function for SWR
const attachmentsFetcher = async (reportId: string): Promise<Attachment[]> => {
  return await apiClient.getAttachmentsByReport(reportId);
};

export const useAttachments = (reportId: string | undefined): UseAttachmentsReturn => {
  const { data, error, isLoading, mutate } = useSWR<Attachment[], Error>(
    reportId ? `/api/v1/attachments/report/${reportId}` : null,
    () => attachmentsFetcher(reportId!),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  const attachments = data ?? [];
  const loading = isLoading;

  return {
    attachments,
    loading,
    error,
    mutate,
  };
};
